// Externe Bibliotheken
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

// Interne Module
import * as storage from '@/_helper/storage';
import { deleteCookie } from '@/_helper/mapper';

const Logout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        storage.clear();
        storage.set('logout', true);
        sessionStorage.setItem('logout', 'true');

        sessionStorage.removeItem('tabID');
        sessionStorage.removeItem('redirect_page');
        sessionStorage.removeItem('linkOutTrigger');

        deleteCookie('_rebook-success');

        let domain = window.location.hostname;
        if (window.location.hostname.split('.').length > 1) {
            domain =
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 2] +
                '.' +
                window.location.hostname.split('.')[window.location.hostname.split('.').length - 1];
        }
        document.cookie =
            'loggedIn=; expires=' +
            new Date(new Date().getTime() + -1 * 24 * 60 * 60 * 1000) +
            ';domain=' +
            domain +
            ';path=/;secure;SameSite=Strict';

        navigate('/login', { state: { autologout: location.state?.autologout || false } });
    }, [location.state?.autologout, navigate]);

    return null;
};
export default Logout;
